import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MinuteRequestApprovalRuleService } from '../../services/minute-request-approval-rule.service';
import { MinuteApprovalParameterDTO } from '../../interfaces/minue-request-approval-paramters.interface';
import { MinuteApprovalConditionComparator } from '../../interfaces/minute-request-approval-rule.interface';
import { map, Observable } from 'rxjs';
import { RoleSummaryDTO } from 'src/app/pages/inner-security/interfaces/roles.interfaces';
import { AddUpdateApprovalMinuteConditionDTO, RegisterMinuteRequestApprovalRuleDTO, RoleToAssignToMinuteApprovalRule } from '../../interfaces/minute-request-approval-rule-manage.interface';
import { RolesService } from 'src/app/pages/inner-security/services/roles.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-register-minute-approval-rule-modal',
  templateUrl: './register-minute-approval-rule-modal.component.html',
  styleUrls: ['./register-minute-approval-rule-modal.component.scss']
})
export class RegisterMinuteApprovalRuleModalComponent implements OnInit{

  public rolesToAssign$: Observable<RoleToAssignToMinuteApprovalRule[]>;
  public approvalParameters: MinuteApprovalParameterDTO[];
  public comparators = MinuteApprovalConditionComparator;
  public conditionsCols = [
    'parameter',
    'comparator',
    'value'
  ];

  public registerForm: FormGroup;
  constructor(private dialogRef: MatDialogRef<RegisterMinuteApprovalRuleModalComponent>,
    private fb: FormBuilder,
    private minuteRequestApprovalRuleService: MinuteRequestApprovalRuleService,
    private rolesService: RolesService
  ){
    this.approvalParameters = [];
    this.registerForm = this.fb.group({
      name: ['', Validators.required],
      description: [''],
      priority: [null, [Validators.required, Validators.min(1)]],
      requiredApproval: [null,[Validators.required, Validators.min(1)]],
      roles: [null, Validators.required],
      conditions: this.fb.array([]),
    });
  }

  ngOnInit(): void {
    this.getAllMinuteApprovalParameters();
    this.getRolesToAssign();
  }

  public getRolesToAssign(){
    this.rolesToAssign$ = this.rolesService.getAllRoles()
    .pipe(
      map(roles => {
        return roles.map(r => <RoleToAssignToMinuteApprovalRule>{
          roleId: r.roleId,
          name: r.name
        });
      })
    )

  }

  public getConditionGroup(index: number): FormGroup {
    return this.conditions.at(index) as FormGroup;
  }

  public getAllMinuteApprovalParameters() {
    this.minuteRequestApprovalRuleService.getAllMinuteApprovalParameters()
    .subscribe(receiveParams => this.approvalParameters = receiveParams);
  }

  get conditions(){
    return this.registerForm.get('conditions') as FormArray;
  }

  public addCondition() {
    this.conditions.push(
      this.fb.group({
        parameterId: [null, Validators.required],
        comparator: [null, Validators.required],
        value: [null, Validators.required]
      })
    );
  }

  public removeCondition(idx: number){ 
    this.conditions.removeAt(idx);
  }

  public clickCloseDialog() {
    this.dialogRef.close(false);
  }

  public submit() {
    const {
      name, description, priority, requiredApproval, roles
    } = this.registerForm.value;
    const conditions = this.conditions.value;

    const request: RegisterMinuteRequestApprovalRuleDTO = {
      name: name,
      description: description,
      priority: priority,
      minApprovalRequired: requiredApproval,
      roles: roles,
      conditions: conditions.map(c => <AddUpdateApprovalMinuteConditionDTO>{
        minuteRequestApprovalParameterId: c.parameterId,
        comparator: c.comparator,
        value: c.value
      })
    };

    Swal.fire({
      title: 'Registrando regla de aprobación',
      didOpen: () => {
        Swal.showLoading();
        this.minuteRequestApprovalRuleService.registerNewMinuteRequestApprovalRule(request)
        .subscribe({
          next:(res) => {
            Swal.fire({
              icon: 'success',
              title: res.resultMessage,
              didClose: () => {
                this.dialogRef.close(true);
              },
            });
          },
          error:(err) => {
            Swal.fire({
              icon: 'error',
              title: err.error.resultMessage || 'Ha ocurrido un error'
            });
          }
        })
      }
    })

  }
}
